import { authFetch, buildApiUrl } from "./authService";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API_URL_HEY_NOW = process.env.REACT_APP_HEY_LOGIN;
const USUARIO_HEY = process.env.REACT_APP_USUARIO_HEY;
const PASSWORD_HEY = process.env.REACT_APP_PASSWORD_HEY;
const HEY_NOW_MESSAGE = process.env.REACT_APP_HEY_NOW_MESSAGE;
const API_CART_URL = process.env.REACT_APP_API_CART_URL;

const HEY_PARTNER_TOKEN = String(
  process.env.REACT_APP_HEY_PARTNER_TOKEN || "fenalco$"
)
  .trim()
  .replace(/^["']|["']$/g, "");
const HEY_PARTNER_USER_ID = parseInt(
  process.env.REACT_APP_HEY_PARTNER_USER_ID || "49",
  10
);
const HEY_PARTNER_USER_NAMES =
  process.env.REACT_APP_HEY_PARTNER_USER_NAMES || "Alejandro";
const HEY_PARTNER_USER_LAST_NAMES =
  process.env.REACT_APP_HEY_PARTNER_USER_LAST_NAMES || "Marin";
const HEY_CONFIRM_ORDER_URL =
  process.env.REACT_APP_HEY_CONFIRM_ORDER_URL ||
  "https://hhkqnrfciyctnsz2oo2cgzgb6q.apigateway.sa-bogota-1.oci.customer-oci.com/hey-v1/actions/35/736667109527733";
const HEY_CONFIRM_ORDER_ACTION =
  process.env.REACT_APP_HEY_CONFIRM_ORDER_ACTION || "msg_pide_confirmar_pedido";

const formatCOP = (value) =>
  new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

const getProductKey = (product) =>
  String(product?.app_item_id ?? product?.item_id ?? product?.id ?? "").trim();

const maskSecret = (value) => {
  const normalized = String(value || "").trim();

  if (!normalized) {
    return "(empty)";
  }

  if (normalized.length <= 4) {
    return `${normalized[0] || ""}*** (${normalized.length})`;
  }

  return `${normalized.slice(0, 3)}...${normalized.slice(-2)} (${normalized.length})`;
};

const buildHeyNowUrl = (phone) => {
  const baseHeyMessage = `${HEY_NOW_MESSAGE}${phone}`;
  let heynowOrigin = null;

  try {
    heynowOrigin = new URL(baseHeyMessage).origin;
  } catch (error) {
    heynowOrigin = null;
  }

  return buildApiUrl(baseHeyMessage, {
    allowedOrigins: heynowOrigin ? [heynowOrigin] : [],
  });
};

const buildHeyNowConfirmOrderUrl = (phone, sessionWhatsapp) => {
  const segments = [HEY_CONFIRM_ORDER_URL];

  if (phone) {
    segments.push(encodeURIComponent(phone));
  }

  if (sessionWhatsapp) {
    segments.push(encodeURIComponent(sessionWhatsapp));
  }

  const baseConfirmOrderUrl = segments.join("/");
  let heynowOrigin = null;

  try {
    heynowOrigin = new URL(baseConfirmOrderUrl).origin;
  } catch (error) {
    heynowOrigin = null;
  }

  return buildApiUrl(baseConfirmOrderUrl, {
    allowedOrigins: heynowOrigin ? [heynowOrigin] : [],
  });
};

const getDeliveryValueFromCart = (data) => {
  const cartTypeId = String(
    data?.cart_type?.id ?? data?.cart?.cart_type?.id ?? data?.result?.cart_type?.id ?? ""
  ).trim();

  // cart_type.id = 1 means pickup, so delivery fee must not be charged.
  if (cartTypeId === "1") {
    return 0;
  }

  const candidates = [
    data?.valorDomicilio,
    data?.sede?.delivery_fee,
    data?.delivery_value,
    data?.delivery_amount,
    data?.shipping_amount,
    data?.shipping_cost,
    data?.cart?.valorDomicilio,
    data?.cart?.delivery_value,
    data?.cart?.delivery_amount,
    data?.cart?.shipping_amount,
    data?.cart?.shipping_cost,
    data?.result?.valorDomicilio,
    data?.result?.delivery_value,
    data?.result?.delivery_amount,
    data?.result?.shipping_amount,
    data?.result?.shipping_cost,
  ];

  const resolved = candidates.find(
    (value) => value !== undefined && value !== null && value !== ""
  );

  const parsed = Number(resolved);
  return Number.isFinite(parsed) ? parsed : 0;
};

const getClientPhoneFromCart = (data) => {
  const candidates = [
    data?.client?.cellphone,
    data?.client?.phone,
    data?.client?.mobile,
    data?.client?.mobile_phone,
    data?.client?.phone_sanitized,
    data?.client?.cellphone_sanitized,
    data?.cart?.client?.cellphone,
    data?.cart?.client?.phone,
    data?.cart?.client?.mobile,
    data?.cart?.client?.mobile_phone,
    data?.cart?.client?.phone_sanitized,
    data?.cart?.client?.cellphone_sanitized,
    data?.result?.client?.cellphone,
    data?.result?.client?.phone,
    data?.result?.client?.mobile,
    data?.result?.client?.mobile_phone,
    data?.result?.client?.phone_sanitized,
    data?.result?.client?.cellphone_sanitized,
    data?.cellphone,
    data?.phone,
    data?.mobile,
    data?.mobile_phone,
  ];

  const resolved = candidates.find(
    (value) => value !== undefined && value !== null && String(value).trim() !== ""
  );

  if (!resolved) {
    return null;
  }

  return String(resolved).replace(/[^\d]/g, "").trim() || null;
};

const getSessionWhatsappFromCart = (data) => {
  const candidates = [
    data?.session_whatsapp,
    data?.cart?.session_whatsapp,
    data?.result?.session_whatsapp,
    data?.client?.session_whatsapp,
    data?.cart?.client?.session_whatsapp,
    data?.result?.client?.session_whatsapp,
  ];

  const resolved = candidates.find(
    (value) => value !== undefined && value !== null && String(value).trim() !== ""
  );

  return resolved ? String(resolved).trim() : null;
};

const fetchCartData = async (tokenFromUrl) => {
  const response = await authFetch(
    `${API_CART_URL}${encodeURIComponent(tokenFromUrl)}`
  );

  if (!response.ok) {
    throw new Error("Error en la solicitud HTTP");
  }

  return response.json();
};

const buildPartnerUserPayload = () => ({
  id: HEY_PARTNER_USER_ID,
  names: HEY_PARTNER_USER_NAMES,
  lastNames: HEY_PARTNER_USER_LAST_NAMES,
});

const confirmOrderMessage = async (phone, sessionWhatsapp) => {
  const confirmOrderUrl = buildHeyNowConfirmOrderUrl(phone, sessionWhatsapp);

  console.info("[WhatsApp] Ejecutando accion de confirmacion de pedido", {
    confirmOrderUrl,
    action: HEY_CONFIRM_ORDER_ACTION,
    partnerTokenMask: maskSecret(HEY_PARTNER_TOKEN),
  });

  const response = await fetch(confirmOrderUrl, {
    method: "PUT",
    headers: {
      "partner-token": HEY_PARTNER_TOKEN,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      action: HEY_CONFIRM_ORDER_ACTION,
      partnerUser: buildPartnerUserPayload(),
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error("Error ejecutando accion de confirmacion del pedido:", errorText);
    throw new Error(`Error sending WhatsApp confirmation action: ${response.status}`);
  }

  const responseText = await response.text();
  console.info("[WhatsApp] Accion de confirmacion ejecutada correctamente", {
    status: response.status,
    responseText,
  });

  return responseText;
};

const getToken = async () => {
  try {
    const response = await fetch(buildApiUrl(API_URL_HEY_NOW), {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: USUARIO_HEY,
        password: PASSWORD_HEY,
      }),
    });

    const data = await response.json();
    return data.token;
  } catch (error) {
    console.error("Error al obtener el token:", error);
    return null;
  }
};

const ExecApiDetailOrderWhatsap = async (
  tokenFromUrl,
  selectedProducts,
  phone,
  item_pedidos_ids,
  total
) => {
  console.info("[WhatsApp] Preparando envio de detalle del pedido", {
    tokenFromUrl,
    phone,
    total,
    products: selectedProducts?.length || 0,
  });

  const combinedProducts = selectedProducts.map((product) => {
    const productWithDetails = item_pedidos_ids.find(
      (item) => getProductKey(item) === getProductKey(product)
    );

    return {
      ...product,
      sub_item_list: productWithDetails ? productWithDetails.sub_item_list : [],
    };
  });

  try {
    const fullUrl = buildHeyNowUrl(phone);
    const cartData = await fetchCartData(tokenFromUrl);
    const clientPhone = getClientPhoneFromCart(cartData) || phone;
    const domicilio = getDeliveryValueFromCart(cartData);
    const sessionWhatsapp = getSessionWhatsappFromCart(cartData);
    const formattedDomicilio = formatCOP(domicilio);
    const formattedTotal = formatCOP(total + domicilio);
    const formattedSubTotal = formatCOP(total);

    let messageText = "Revisemos tu pedido:\n\n";
    messageText += "*Productos seleccionados:*\n\n";

    combinedProducts.forEach((product) => {
      const formattedPrice = formatCOP(product.price * product.quantity);
      messageText += `*${product.quantity} ${product.name}*.\n`;
      messageText += `- _Precio: ${formattedPrice}_\n\n`;

      if (product.sub_item_list && product.sub_item_list.length > 0) {
        messageText += "*Acompanamientos:* \n";
        product.sub_item_list.forEach((subItem) => {
          const formattedAcompanante = formatCOP(
            subItem.price * subItem.quantity
          );
          messageText += `- ${subItem.quantity} ${subItem.name_modifier_groups}, -Precio: (${formattedAcompanante})\n`;
        });
      }

      messageText += "\n\n";
    });

    messageText += `-Valor domicilio: (${formattedDomicilio})_\n\n`;
    messageText += `> *Subtotal:* ${formattedSubTotal}\n`;
    messageText += `> *Total a pagar:* ${formattedTotal}\n`;

    console.info("[WhatsApp] Payload listo para enviar", {
      fullUrl,
      clientPhone,
      domicilio,
      sessionWhatsapp,
      combinedProducts,
      messagePreview: messageText,
      partnerTokenMask: maskSecret(HEY_PARTNER_TOKEN),
    });

    const response = await fetch(fullUrl, {
      method: "POST",
      headers: {
        "partner-token": HEY_PARTNER_TOKEN,
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        partnerUser: buildPartnerUserPayload(),
        text: messageText,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error enviando detalle del pedido a WhatsApp:", errorText);
      throw new Error(`Error sending WhatsApp order detail: ${response.status}`);
    }

    const responseText = await response.text();
    const confirmResponseText = await confirmOrderMessage(
      clientPhone,
      sessionWhatsapp
    );
    console.info("[WhatsApp] Detalle enviado correctamente", {
      status: response.status,
      responseText,
      confirmResponseText,
    });
    return {
      ok: true,
      responseText,
      confirmResponseText,
    };
  } catch (error) {
    console.error("Error al procesar la solicitud:", error);
    return {
      ok: false,
      error,
    };
  }
};

export const checkPhoneclient = async (tokenFromUrl) => {
  try {
    const data = await fetchCartData(tokenFromUrl);
    // API returns { token, active } — no phone field
    // Phone is obtained from sessionData.client.cellphone in callers
    return getClientPhoneFromCart(data);
  } catch (error) {
    console.error("Error al obtener el teléfono del cliente:", error);
    return null;
  }
};

const checkTokenActive = async (tokenFromUrl) => {
  try {
    const response = await authFetch(`${API_BASE_URL}/session/token/validate`, {
      method: "POST",
      body: JSON.stringify({
        token: tokenFromUrl,
      }),
    });

    if (!response.ok) {
      throw new Error("Error en la solicitud HTTP");
    }

    const data = await response.json();
    return data?.active === true;
  } catch (error) {
    console.error("Error al validar el token:", error);
    return false;
  }
};

const checkAddressValue = async (tokenFromUrl) => {
  try {
    const data = await fetchCartData(tokenFromUrl);
    return getDeliveryValueFromCart(data);
  } catch (error) {
    console.error("Error al procesar la solicitud:", error);
    return 0;
  }
};

const updateCartProducts = async (tokenFromUrl, products) => {
  try {
    const urlWithToken = `${API_CART_URL}${encodeURIComponent(tokenFromUrl)}`;
    const response = await authFetch(urlWithToken, {
      method: "POST",
      body: JSON.stringify({
        products,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        `Error ${response.status} al actualizar productos del carrito:`,
        errorText
      );
      throw new Error(`Error updating cart products: ${response.status}`);
    }

    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
      return await response.json();
    }

    return await response.text();
  } catch (error) {
    console.error("Error al actualizar productos del carrito:", error);
    throw error;
  }
};

export {
  getToken,
  ExecApiDetailOrderWhatsap,
  checkTokenActive,
  updateCartProducts,
};
